import Store from "@/store/index.js";
import axios from "axios";
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
const domain = Store.state.domain;

export default {
    VisualizarArchivo(data) {
        return axios.post(`${domain.domainNameForApi}Finanzas/VisualizarArchivo`, data).then((response) => response.data);
    },
    VisualizarXML(data) {
        return axios.post(`${domain.domainNameForApi}Finanzas/VisualizarXML`, data).then((response) => response.data);
    },
    DescargarArchivo(data) {
        return axios.post(`${domain.domainNameForApi}Finanzas/DescargarArchivo`, data, { responseType: 'blob', }).then((response) => response.data);
    },
}